import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import reserva from './reserva'
import reservav2 from './reservav2'
import autenticacion from './autenticacion'
import moment from 'moment'
/* trying vuex  06/09/20*/

//para persistir datos
import createPersistedState from "vuex-persistedstate"
axios.defaults.baseURL = process.env.VUE_APP_API_URL

import SecureLS from "secure-ls";
var ls = new SecureLS({encodingType: 'rc4', isCompression: false, encryptionSecret: 's3cr3tPa$$w0rd@123'});

Vue.use(Vuex)

const dataState = createPersistedState({
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
  },
  paths: [
            'reserva.sendReservation', 
            'reserva.precalculo', 
            'reserva.sucursales',
            'reserva.calculo',
            'reserva.procesoReserva',
            'reserva.addEdd',
            'reserva.addCap',
            'reserva.addClp',
            'reserva.addRap',
            'reserva.addMifi',
            'reserva.addSillabb',
            'reserva.montoExtras',
            'reserva.subTotal',
            'reserva.apo_fee',
            'reserva.itbms',
            'reserva.tarifa',
            'reserva.porcentaje_sucursal',
            'reserva.auto',
            'reserva.reserveConfirm',
            'reserva.forma_pago',
            'autenticacion.user',
            'autenticacion.welcome',

            // version 2
            'reservav2.sucursales',
            'reservav2.data',
            'reservav2.precalculo',
            'reservav2.procesoReserva',
            'reservav2.addEdd',
            'reservav2.addCap',
            'reservav2.addClp',
            'reservav2.addRap',
            'reservav2.addMifi',
            'reservav2.addSillabb',
            'reservav2.addCondAdic',
            'reservav2.calculo',
            'reservav2.auto',
            'reservav2.forma_pago', 
            'reservav2.reserve',
            'reservav2.reservaPreCalculada',
            'reservav2.accion_modificar',
          ]
})

export default new Vuex.Store({
  state: {
    locations:[],
    cities:[],
    fleet:[],
    filteredCar:'',
    menulocationfilter:'',
    contacto_leasing:{
      nombre_empresa:'',
      ruc: '',
      contacto:'',
      tel:'',
      email:'',
      mensaje:''
    },
    brand:3,
    cliente: false, // para mostrar o no sistema de login
    dateNow: moment().format('MMMM Do YYYY, h:mm:ss a') // August 11th 2021, 3:40:02 pm
  },
  mutations: {
    locationsList(state, resp){
      state.locations = resp
    },
    fleetList(state, resp){
      state.fleet = resp
    },
    mutateCarFilter(state, car){
      state.filteredCar = car
    },
    locationMenuFilter(state, loc){
      state.menulocationfilter = loc
    },
    citieslist(state, resp){
      state.cities = resp
      /* console.log(resp.data) */
    },
    
  },
  actions: {
    getLocationsList({commit}){
      axios
      .get('sucursales/3')
      .then(resp=>{
      commit('locationsList', resp)
    })
    },
    getcitiesList({commit}){
      axios
      .get('mostrar-menu-sucursal')
      .then(resp=>{
      commit('citieslist', resp)
    })
    .catch(()=>{
      //console.clear()
    })
    },
    getFleetList({commit, state}){
      axios
      .post('flota', {brand:3})
      .then(resp=>{
      commit('fleetList', resp)
    })
    },

    addCarFilter(context, payload){
      context.commit('mutateCarFilter', payload)
    },
    addLocationMenuFilter(context, payload){
      context.commit('locationMenuFilter', payload)
    },

    // envio de correo contacto leasing
    sendMailLeasing({state})
    {
      axios.post('contacto-leasing', state.contacto_leasing)
    }
  },
  modules: {
    reserva,
    reservav2,
    autenticacion
  },
  plugins: [dataState],
})
